import { title } from '@/utilities/filters'
import i18n from '@/plugins/i18n'

const isDev = process.env.NODE_ENV === 'development'

const getLayout = () => `${isDev ? 'fake-site' : 'default'}-layout`

const routes = [
  {
    component: () =>
      import(/* webpackChunkName: "Conditions" */ '@/views/conditions/Conditions.vue'),
    meta: {
      layout: getLayout(),
      title: title(String(i18n.t('org.conditions'))),
    },
    name: 'Conditions',
    path: '/results/a-z-conditions',
  },
  {
    component: () => import(/* webpackChunkName: "Results" */ '@/views/results/Results.vue'),
    meta: {
      layout: getLayout(),
      title: title(String(i18n.t('org.results'))),
    },
    name: 'Results',
    path: '/results/search-results',
  },
  {
    component: () =>
      import(/* webpackChunkName: "TrialsDetails" */ '@/views/trials/TrialsDetails.vue'),
    meta: {
      layout: getLayout(),
      title: title(String(i18n.t('org.trialsDetails'))),
    },
    name: 'TrialsDetails',
    path: '/trial-details/trial-detail',
  },
]

export default routes
